module.exports = __webpack_public_path__ + "img/broadcast.bfa8ce7b.svg";